export enum FilterType {
   DepartmentFunction = 'departmentFunction',
   Department = 'department',
   BusinessUnit = 'businessUnit',
   DepartmentMultiSelect = 'departmentMultiSelect',
   Rating = 'rating',
   Quarter = 'quarter',
   Status = 'status',
}
